const { useEffect, useState } = require('react');

/** updates state when an elements dimensions change */
exports.useElementDimensions = () => {
  // using useState rather than useRef to trigger rerenders
  // useful if element is unmounted/remounted
  const [elementRef, setElementRef] = useState(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const handleResize = () => {
      if (elementRef) {
        const { width, height } = elementRef.getBoundingClientRect();
        setDimensions({ width, height });
      }
    };

    handleResize();
    const observer = new ResizeObserver(handleResize);
    if (elementRef) {
      observer.observe(elementRef);
      return () => {
        observer.unobserve(elementRef);
      };
    }
  }, [elementRef]);

  return [setElementRef, dimensions];
};
